import htmlTemplate from "./agencyVerificationPDFTemplate.js";

const loadScript = (src, attrs, useDefer = false) => {
  return new Promise((resolve, reject) => {
    if (!document.querySelector(`head > script[src="${src}"]`)) {
      const script = document.createElement("script");
      script.src = src;
      if (attrs) {
        for (const attr in attrs) {
          script.setAttribute(attr, attrs[attr]);
        }
      }
      if (useDefer) {
        script.async = true;
        script.defer = true;
      }
      script.onload = resolve;
      script.onerror = reject;
      document.head.append(script);
    } else {
      resolve();
    }
  });
};

const getBase64Image = url => {
  const img = new Image();
  img.setAttribute("crossOrigin", "anonymous");
  img.onload = () => {
    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
  };

  img.src = url;
  return img;
};

const getNormalizedDate = () => {
  const dateObj = new Date();
  const month = dateObj.getUTCMonth() + 1;
  const day = dateObj.getUTCDate();
  const year = dateObj.getUTCFullYear();

  return `${month}/${day}/${year}`;
};

const readTemplateConfig = pdfTemplateBlock => {
  const config = {};
  pdfTemplateBlock.querySelectorAll(":scope > div").forEach(row => {
    if (row.children) {
      const cols = [...row.children];
      if (cols[1]) {
        const col = cols[1];
        const name =
          typeof cols[0].textContent === "string"
            ? cols[0].textContent
                .toLowerCase()
                .replace(/[^0-9a-z]/gi, "-")
                .replace(/-+/g, "-")
                .replace(/^-|-$/g, "")
            : "";
        let value = "";
        if (col.querySelector("img")) {
          const imgs = [...col.querySelectorAll("img")];
          if (imgs.length === 1) {
            value = imgs[0].src;
          } else {
            value = imgs.map(img => img.src);
          }
        } else if (col.querySelector("p")) {
          const ps = [...col.querySelectorAll("p")];
          if (ps.length === 1) {
            value = ps[0].textContent;
          } else {
            value = ps.map(p => p.textContent).join("\r\n\r\n");
          }
        } else value = row.children[1].textContent;
        config[name] = value;
      }
    }
  });

  return config;
};

export const renderAgencyVerificationPDF = async office => {
  if (!window.jspdf) {
    await loadScript("https://unpkg.com/jspdf@latest/dist/jspdf.umd.min.js", {
      type: "text/javascript",
    });
  }
  const { jsPDF } = window.jspdf;

  const dp = new DOMParser();
  const templateDoc = dp.parseFromString(htmlTemplate, "text/html");
  const pdfTemplateBlock = templateDoc.querySelector(".pdf-values");
  if (pdfTemplateBlock) {
    const cfg = readTemplateConfig(pdfTemplateBlock);

    // eslint-disable-next-line new-cap
    const doc = new window.jspdf.jsPDF();
    const title = `${office.details.title} "Verification Letter"`;

    doc.setProperties({
      title,
    });

    const headerImage = getBase64Image(
      "/assets/Website-build/img/agency-verification-pdf-logo.png",
    );
    doc.addImage(headerImage, "PNG", 10, 10, 190, 23); // the header image
    doc.text(getNormalizedDate(), 10, 40); // the date
    doc.setFontSize(20);
    const splitTitle = doc.splitTextToSize(cfg["pdf-title"], 200);
    let yPosition = 50;
    doc.text(splitTitle, 10, yPosition); // the title (static for all generated PDFs)
    doc.setFontSize(16);
    doc.setFont("Helvetica", "bold");
    yPosition += 30;
    doc.text(`${office.details.title}`, 10, yPosition); // the agency name
    doc.setFont("Helvetica", "normal");
    yPosition += 8;
    doc.text(`${office.details.mailingAddress.street}`, 10, yPosition); // address line 1

    if (office.details.mailingAddress.street2) {
      yPosition += 8;
      doc.text(`${office.details.mailingAddress.street2}`, 10, yPosition); // address line 2
    }

    yPosition += 8;
    doc.text(
      `${office.details.mailingAddress.city}, ${office.details.mailingAddress.state} ${office.details.mailingAddress.zip}`,
      10,
      yPosition,
    ); // address line 3
    doc.setFont("Helvetica", "bold");
    yPosition += 8;
    doc.text(`Service State: ${office.serviceState}`, 10, yPosition); // service state
    yPosition += 10;
    doc.line(10, yPosition, 200, yPosition);
    yPosition += 10;
    doc.setFont("Helvetica", "normal");
    doc.setFontSize(12);
    const legal1 = cfg["legal-1"]
      .replaceAll("{{date}}", getNormalizedDate())
      .replaceAll("{{officeDisplayName}}", office.details.title);
    const splitLegal1 = doc.splitTextToSize(legal1, 190);
    doc.text(splitLegal1, 10, yPosition); // legal text 1

    yPosition += 55;
    doc.setFont("Helvetica", "bold");
    doc.text(cfg["about-stewart-trusted"], 10, yPosition); // legal text 2 title

    yPosition += 10;
    doc.setFont("Helvetica", "normal");
    const splitLegal2 = doc.splitTextToSize(cfg["legal-2"], 190);
    doc.text(splitLegal2, 10, yPosition); // legal text 2

    doc.autoPrint({ variant: "non-conform" });
    window.open(doc.output("bloburl"), "_blank");
  }
};
